import update from 'immutability-helper';

export default function clearChartUpdated(state, action) {
  console.log('CLEAR_CHART_UPDATED', action);

  return update(state, {
    chartUpdated: {
      $set: false,
    },
  });
}
